import { render, staticRenderFns } from "./RelSolicitacoes.vue?vue&type=template&id=7bf956ff&"
import script from "./RelSolicitacoes.vue?vue&type=script&lang=js&"
export * from "./RelSolicitacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports